import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

export type PartnerDeletionPreviewReferences = {
  shares: number;
  operations: number;
  operationRaws: number;
  customMovements: number;
  boards: number;
  partnerRepresentants: number;
  sharesTitles: number;
  sharesOwnershipCertificates: number;
  stockPlans: number;
  tradingOffers: number;
  tradingOfferOperations: number;
  tenderOfferShares: number;
  investors: number;
  notes: number;
  observations: number;
  partnerDocuments: number;
};

export type PartnerDeletionPreview = {
  partnerId: string;
  partnerName: string;
  societyId: string;
  canDelete: boolean;
  blockingTotal: number;
  references: PartnerDeletionPreviewReferences;
  cleanup: {
    societyMembership: number;
    userLinks: number;
  };
};

export const getPartnerDeletionPreview = async (
  partnerId: string
): Promise<PartnerDeletionPreview> => {
  const { data } = await axiosV2.get(
    `/partners/${partnerId}/deletion-preview`
  );

  return decryptResponse(data) as Promise<PartnerDeletionPreview>;
};
